import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ClientRegular, ClientStatus } from '@fitness-force/enum';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'client-status',
  templateUrl: './client-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe],
})
export class ClientStatusComponent implements OnInit {
  additionData: Observable<any> = new BehaviorSubject(null);
  columnData: Observable<any> = new BehaviorSubject(null);
  constructor() {}

  regularStatus: any = ClientRegular;

  ngOnInit(): void {}

  getClientStatusHtml(clientStatus: string): string {
    let status = ClientStatus[Number(clientStatus)];
    switch (status) {
      case ClientStatus.Prospect.toString():
      case ClientStatus[ClientStatus.Prospect]:
        return '<span class="bg-pink-50 text-pink-500 px-2 py-1 line-height-3 font-bold border-round text-xxs">PROSPECT</span>';
      case ClientStatus.Trial.toString():
      case ClientStatus[ClientStatus.Trial]:
        return '<span class="bg-cyan-50 text-cyan-500 px-2 py-1 line-height-3 font-bold border-round text-xxs">TRIAL</span>';
      case ClientStatus.Client.toString():
      case ClientStatus[ClientStatus.Client]:
        return '<span class="bg-green-50 text-green-500 px-2 py-1 line-height-3 font-bold border-round text-xxs">MEMBER</span>';
      case ClientStatus.ClientNonMember.toString():
      case ClientStatus[ClientStatus.ClientNonMember]:
        return '<span class="bg-yellow-50 text-yellow-500 px-2 py-1 line-height-3 font-bold border-round text-xxs">NON-MEMBER</span>';
      case ClientStatus.ExClient.toString():
      case ClientStatus[ClientStatus.ExClient]:
        return '<span class="surface-50 text-500 px-2 py-1 line-height-3 font-bold border-round text-xxs">EX-MEMBER</span>';
      case ClientStatus.BlockedClient.toString():
      case ClientStatus[ClientStatus.BlockedClient]:
        return '<span class="bg-bluegray-50 text-bluegray-500 px-2 py-1 font-bold border-round text-xxs">TERMINATED</span>';
      case ClientStatus.ExClientNonMember.toString():
      case ClientStatus[ClientStatus.ExClientNonMember]:
        return '<span class="surface-100 text-800 px-2 py-1 font-bold border-round text-xxs">EX-CLIENT NON-MEMBER</span>';
      default:
        return '';
    }
  }
}
